import type { AssistantVoiceText } from "@/locales/assistant-voice";
import type { WallMicState, WallNocMicMode } from "@/types/ai-assistant-voice";
import { fillTemplate } from "../assistant.logic";

/** Logika murni kontrol Mode NOC di /wall (lencana mikrofon, tombol bicara, tombol Spasi). */

export interface NocBadge {
	label: string;
	color: string;
}

/** Lencana besar: warna kontras tinggi per keadaan mikrofon. */
export function nocBadge(
	state: WallMicState,
	t: AssistantVoiceText,
	name: string,
): NocBadge {
	if (state === "open") return { label: t.noc.micOpen, color: "green.9" };
	if (state === "ai_speaking")
		return {
			label: fillTemplate(t.noc.aiSpeaking, { name }),
			color: "violet.9",
		};
	return { label: t.noc.micClosed, color: "dark.9" };
}

/** Tombol bicara hanya ada di mode yang memakainya; `gate` murni otomatis. */
export function showsPttButton(micMode: WallNocMicMode): boolean {
	return micMode !== "gate";
}

/** Tombol bicara hanya berfungsi bila sesi suara sudah tersambung. */
export function pttEnabled(status: string): boolean {
	return status === "ready" || status === "listening" || status === "answering";
}

const EDITABLE_TAGS = new Set(["INPUT", "TEXTAREA", "SELECT"]);

/** Spasi sedang mengetik di kolom isian: jangan dijadikan tombol bicara. */
export function isEditableTarget(target: EventTarget | null): boolean {
	const el = target as HTMLElement | null;
	if (!el || typeof el.tagName !== "string") return false;
	return EDITABLE_TAGS.has(el.tagName) || el.isContentEditable === true;
}

export function isSpaceKey(e: { code?: string; key?: string }): boolean {
	return e.code === "Space" || e.key === " ";
}
